import { ReactNode, SVGProps, useMemo, memo } from 'react';
import chroma from 'chroma-js';
import uniqueId from 'lodash/uniqueId';
import {
  BaseContainerComponentPropsType,
} from '../util/types';
import { makeClassName } from '@siteless/util';

export type RenderShadowFn = (
  args: {
    style: { fill: string };
    clipPath: string;
  } & SVGProps<SVGPolygonElement>,
) => ReactNode;

const clipId = uniqueId('clipPath');

const AvatarArtwork = memo(
  ({
    className,
    children,
    defaultBackgroundColor,
    backgroundColor: propsBackgroundColor,
    renderShadow,
    ...rest
  }: BaseContainerComponentPropsType & {
    defaultBackgroundColor: string;
    backgroundColor?: string;
    renderShadow: RenderShadowFn;
  } & Omit<SVGProps<SVGSVGElement>, 'ref'>) => {
    const backgroundColor =
      propsBackgroundColor || defaultBackgroundColor || '#ffffff';
    const shadowStyle = useMemo(
      () => ({
        fill: chroma(backgroundColor).darken(0.4).desaturate(0.3).hex(),
      }),
      [backgroundColor],
    );

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        className={makeClassName('rounded-full overflow-hidden', className)}
        {...rest}
      >
        <circle cx="24" cy="24" r="24" style={{ fill: backgroundColor }} />
        <clipPath id={clipId}>
          <circle cx="24" cy="24" r="24" />
        </clipPath>
        <g clipPath={`url(#${clipId})`}>
          {renderShadow &&
            renderShadow({ style: shadowStyle, clipPath: `url(#${clipId})` })}
        </g>
        <g clipPath={`url(#${clipId})`}>{children}</g>
      </svg>
    );
  },
);

export default AvatarArtwork;
